<mat-toolbar class="subtitulo">Planos de Contas</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-icon matPrefix>search</mat-icon>
                <div ngModelGroup="mgComboPlanosContas" fxFlex="100%" fxLayoutGap="20px" >
                    <combo-pesquisavel #cbPlanosContas 
                                        nome="planosContas" 
                                        [itens]="comboPlanosContas" 
                                        itemDescricao="planoConta"
                                        itemId="id"
                                        [showDisplayId]="false" 
                                        [obrigatorio]="false"
                                        label="Rúbrica"
                                        placeholder="Selecione uma rubrica"
                                        [(valor)]="selecionado">
                    </combo-pesquisavel>
                </div>
            </div>        
            

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 20px">
            <div>
                <button matTooltip="Adicionar nova rúbrica" mat-fab color="primary"
                    [routerLink]="['/planoscontascontabeis/cadastrar']" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

            <ng-container matColumnDef="id" style="width: 10%">
                <th mat-header-cell *matHeaderCellDef> Id </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <ng-container matColumnDef="planoconta" style="width: 50%">
                <th mat-header-cell *matHeaderCellDef> Conta Contábil </th>
                <td mat-cell *matCellDef="let element"> {{element.planoConta}} </td>
            </ng-container>

            <ng-container matColumnDef="sintetico" style="width: 25%">
                <th mat-header-cell *matHeaderCellDef> Sintética</th>
                <td mat-cell *matCellDef="let element"> {{element.sintetica ? 'Sim' : 'Não'}} </td>
            </ng-container>

                
            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[20, 50, 100, 150]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

    </div>



</div>
